import moment from "moment";

export const priceformater = (value) => {
  return `$ ${Math.round(value).toLocaleString("en-US")}`;
};

export const UsFormate = (value) => {
  return value.toLocaleString("en-US");
};

// export const UsFormate = (value) => {
//   if (value === null || value === undefined) return ""; // or "0"
//   const num = Number(value);
//   if (isNaN(num)) return ""; // in case value is not a number
//   return num.toLocaleString("en-US");
// };


function ExcelDateToJSDate(date) {
  const datenew = new Date(Math.round((date - 25569) * 86400 * 1000));
  return moment(datenew).format("MM/DD/YYYY");
}
export const getUUID = (e) => {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
    var r = (Math.random() * 16) | 0,
      v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
};
const GiveSoldData = (date) => {
  if (date !== "") {
    if (typeof date === "number") {
      let data = ExcelDateToJSDate(date);
      return data;
    } else {
      return date;
    }
  } else {
    return "Not Available";
  }
};
export const detectCSVType = (item) => {
  if (item["HalfBaths"] !== undefined || item["ThreeQuarterBaths"] !== undefined || item["FG_Style"] !== undefined) {
    return "IRIS";
  } else if (item["Bathrooms Half"] !== undefined || item["Bathrooms Three Quarter"] !== undefined) {
    return "ReColorado";
  }
  // else if (item["BedsTotal"] !== undefined || item["SqftAbove"] !== undefined) {
  //   return "PPAR";
  // }
  else if (item["BathsHalf"] !== undefined || item["BathsThreeQuarter"] !== undefined || item["FloorPlan"] !== undefined || item["BathsFull"] !== undefined) {
    return "PPAR";
  }
  return "ReColorado";
};

const calculateAboveGradeBedroomsFromIRIS = (item) => {
  let aboveGradeCount = 0;
  let belowGradeCount = 0;
  const bedroomFields = [
    "MasterBRLevel",
    "Bedroom2Level",
    "Bedroom3Level",
    "Bedroom4Level",
    "Bedroom5Level",
    "Bedroom6Level"
  ];

  bedroomFields.forEach(field => {
    if (item[field]) {
      const level = item[field].toUpperCase();
      if (level === "M" || level === "U") {
        aboveGradeCount++;
      } else if (level === "B") {
        belowGradeCount++;
      }
    }
  });

  return { aboveGrade: aboveGradeCount, belowGrade: belowGradeCount };
};

const parseFireplaceDescription = (description) => {
  if (!description || description === "") return "";

  const desc = String(description).toLowerCase().trim();

  if (desc.includes("none") || desc.includes("no fireplace") || desc === "0") return 0;
  if (desc.includes("one") || desc === "1") return 1;
  if (desc.includes("two") || desc === "2") return 2;
  if (desc.includes("three") || desc === "3") return 3;
  if (desc.includes("four") || desc === "4") return 4;
  if (desc.includes("five") || desc === "5") return 5;

  const numberMatch = desc.match(/^(\d+)/);
  if (numberMatch) {
    return parseInt(numberMatch[1]);
  }

  return "";
};

export const FunctionFilterCsvData = (allCsvData, type) => {
  let filterCsvData = [];
  let imageIds = [];
  allCsvData?.forEach((item) => {
    const detectedType = type || detectCSVType(item);

    const listingId = item["Listing Id"] || item["ListingId"] || item["MLSNumber"] || item["MLS_ID"];
    if (listingId) {
      imageIds.push(listingId);
    }
    let data;
    if (detectedType === "IRIS") {
      const bedroomCounts = calculateAboveGradeBedroomsFromIRIS(item);
      const fireplaceCount = parseFireplaceDescription(item["Fireplace"]);

      data = {
        Levels: item["FG_Style"] || item["Levels"] || "",
        "Year Built": item["YearBuilt"] || item["Year Built"] || "",
        "Lot Size": item["LotSize"] ? Math.round(item["LotSize"]) : 0,
        "Above Grade Finished Area": item["FinishedSQFT"] || item["MainFloorSQFT"] || 0,
        "Below Grade Total Area": item["BasementSQFT"] || 0,
        "Below Grade Finished Area": (item["FinishedSQFTincBasement"] || 0) - (item["FinishedSQFT"] || 0),
        "Total Square Feet": item["TotalSqFt"] || item["Total Square Feet"] || 0,
        Fireplace: fireplaceCount,
        "Above Grade Bedrooms": bedroomCounts.aboveGrade || 0,
        "¾ and Full Bathrooms":
          (item["FullBaths"] || 0) + (item["ThreeQuarterBaths"] || 0),
        "¼ and ½ Bathrooms": item["HalfBaths"] || 0,
        "Garage Spaces": item["NumGarageSpaces"] || item["Garage Spaces"] || 0,
        properties_address: item["Unit Number"]
          ? `${item["StreetNumber"] || ""} ${item["StreetDirection"] || ""} ${item["StreetName"] || ""} ${item["StreetType"] || ""} ${item["City"] || ""} ${item["State"]?.slice(0, 2).toUpperCase() || ""} ${item["ZipCode"] || ""} (unit ${item["Unit Number"]})`
            .replace(/\s+/g, " ")
            .trim()
          : `${item["StreetNumber"] || ""} ${item["StreetDirection"] || ""} ${item["StreetName"] || ""} ${item["StreetType"] || ""} ${item["City"] || ""} ${item["State"]?.slice(0, 2).toUpperCase() || ""} ${item["ZipCode"] || ""}`
            .replace(/\s+/g, " ")
            .trim(),
        pdf_address: `${item["StreetNumber"]}  ${item["StreetName"]}`,
        add_adjustment: true,
        "Public-Remarks": item["Public"] || item["Public Remarks"] || "Not Available",
        "Net Sales Price":
          (item["SoldPrice"] || item["Close Price"] ? Number(item["SoldPrice"] || item["Close Price"]) : 0) -
          (item["Concession_TotalAmount"] ? Number(item["Concession_TotalAmount"]) : 0),
        notes: "",
        uuid: getUUID(),
        propertyImages: [],
        selectedAdditionalInfo: [],
        subjectAdditionalInfo: [],
        checked: "",
        agentNotes: "",
        "Listing Id": item["Listing Id"] || item["ListingId"] || item["MLSNumber"] || "",
        Latitude: item["Latitude"] || "",
        Longitude: item["Longitude"] || "",
        "Day on market": item["Days In MLS"] || item["DOM"] || item["Days on Market"] || item["DaysOnMarket"] || "",
        Exclusions: item["Exclusions"] || item["ExclusionsRemarks"] || "",
        Roof: item["Roof"] || item["FG_Roof"] || item["RoofType"] || item["RoofMaterial"] || "",
        "kitchen appliences": item["Appliances"] || item["FG_Inclusions"] || item["AppliancesIncluded"] || "",
        "Prop Type": item["Property Sub Type"] || item["PropertySubType"] || item["FG_Type"] || item["PropertyType"] || item["Type"] || "",
        County: item["County Or Parish"] || item["County"] || item["CountyOrParish"] || item["CountyName"] || "",
        "Full baths": item["FullBaths"] || item["Bathrooms Full"] || 0,
        "3/4 baths": item["ThreeQuarterBaths"] || item["Bathrooms Three Quarter"] || 0,
        "Half baths": item["HalfBaths"] || item["Bathrooms Half"] || 0,
        "List Price": item["List Price"] || item["ListPrice"] || item["CurrentPrice"] || 0,
        High: item["High School"] || item["HighSchool"] || item["HighSchoolName"] || "",
        "Org List Price": item["Original List Price"] || item["OriginalListPrice"] || item["ListPrice"] || item["OriginalPrice"] || "",
        Elementary: item["Elementary School"] || item["ElementarySchool"] || item["ElementarySchoolName"] || "",
        "Assoc Fee": item["Association Fee"] || item["AssociationFee"] || item["AssocFee"] || "",
        perSquareFeet: item["PSF Above Grade"] || item["PSFAboveGrade"] ||
          (item["SoldPrice"] && item["TotalSqFt"] && item["TotalSqFt"] > 0
            ? Math.round(item["SoldPrice"] / item["TotalSqFt"])
            : 0),
        "Association Fee Includes": item["Association Fee Includes"] || item["AssociationFeeIncludes"] || "",
        "Association Name Primary": item["Association Name"] || item["AssociationName"] || item["HOAName"] || "",
        "Basement Type": item["Basement"] || item["FG_BasementFoundation"] || item["BasementDescription"] || "",
        Concession: item["Concession_TotalAmount"] !== undefined && item["Concession_TotalAmount"] !== ""
          ? item["Concession_TotalAmount"]
          : 0,
        "Construction Materials": item["Construction Materials"] || item["FG_Construction"] || item["ConstructionMaterials"] || item["ExteriorConstruction"] || "",
        cooling: item["cooling"] || item["Cooling"] || item["FG_Cooling"] || item["CoolingType"] || item["AirConditioning"] || "",
        "Exterior Features": item["Exterior Features"] || item["FG_OutdoorFeatures"] || item["ExteriorFeatures"] || "",
        "Faces Direction": item["Direction Faces"] || item["DirectionFaces"] || item["Orientation"] || "",
        "Fireplace Features": item["Fireplace Features"] || item["FG_Fireplace"] || item["FireplaceFeatures"] || item["FireplaceDescription"] || "",
        Flooring: item["Flooring"] || item["FlooringType"] || "",
        Heating: item["Heating"] || item["FG_Heating"] || item["HeatingType"] || item["HeatingFuel"] || "",
        "Interior Features": item["Interior Features"] || item["FG_PropertyFeatures"] || item["FG_DesignFeatures"] || item["InteriorFeatures"] || "",
        "Is Incorporated YN": item["Is Incorporated YN"] || "",
        "Laundry Features": item["Laundry Features"] || item["LaundryFeatures"] || item["Laundry"] || "",
        "Garage Type": item["GarageType"] || item["Garage Type"] || "",
        "Parking Features": item["Parking Features"] || item["FG_ParkingPerUnit"] || item["ParkingFeatures"] || item["Parking"] || "",
        Restrictions: item["Restrictions Covenants"] || item["Restrictions"] || item["RestrictionsCovenants"] || "",
        "Road Surface": item["Road Surface Type"] || item["FG_RoadSurfaceAtPropertyLine"] || item["RoadSurfaceType"] || item["RoadSurface"] || "",
        Sewer: item["Sewer"] || item["FG_WaterSewer"] || item["SewerType"] || item["SewerDescription"] || "",
        Utilities: item["Utilities"] || item["FG_Utilities"] || item["UtilitiesAvailable"] || item["UtilitiesDescription"] || "",
        View: item["View"] || item["FG_Views"] || item["ViewType"] || item["ViewDescription"] || "",
        Zoning: item["Zoning"] || item["ZoningDescription"] || item["ZoningType"] || "",
        "School District": item["Elementary School District"] || item["SchoolDistrict"] || "",
        MLS: item["Listing Id"] || item["ListingId"] || item["MLSNumber"] || item["MLS_ID"] || "Not Available",
        Neighborhood: item["Subdivision Name"] || item["Subdivision"] || item["SubdivisionName"] || item["Neighborhood"] || "",
        "Structure Style": item["Style"] || item["Structure tupe"] || item["ArchitecturalStyle"] || "",
        Taxes: item["Tax Annual Amount"] || item["TaxYear"] || item["TaxAnnualAmount"] || item["Taxes"] || "",
        "Unit Number": item["Unit Number"] || "",
        Bedrooms: bedroomCounts.aboveGrade || 0,
        Bathrooms: 0,
        added_COMPARABLESLIST: {
          Current_State: item["ListStatus"] || item["Mls Status"] || "Not Available",
          Sold_Date: GiveSoldData(item["SoldDate"] || item["Close Date"]),
          Sold_Price: item["SoldPrice"] || item["Close Price"] || "Not Available",
        },
        additionalHomeFacts: {
          Location: {
            Undesirable: false,
            Noisy: false,
            Average: false,
            Good: false,
            Amazing: false,
          },
          "Basement Type": {
            None: false,
            "In-Ground": false,
            "Garden Level": false,
            Walkout: false,
          },
          Windows: {
            "Below Average": false,
            Average: false,
            "Above Average": false,
            "Excellent New": false,
          },
          "Kitchen Condition": {
            Dated: false,
            "Typical Average": false,
            "Partial Update Low": false,
            "Partial Update High": false,
            "Full Update": false,
          },
          "Bathroom Condition": {
            Dated: false,
            "Typical Average": false,
            "Partial Update Low": false,
            "Partial Update High": false,
            "Full Update": false,
          },
          "Heating/Cooling": {
            None: false,
            Evaporative: false,
            "Central Air": false,
            "Split Zone": false,
          },
        },
        adjustment_formulas: [],
        review_data: {},
      };
    } else if (detectedType === "ReColorado") {
      data = {
        Levels: item["Levels"],
        "Year Built": item["Year Built"],
        "Lot Size": item["Lot Size Square Feet"]
          ? Math.round(item["Lot Size Square Feet"])
          : 0,
        "Above Grade Finished Area": item["Above Grade Finished Area"]
          ? item["Above Grade Finished Area"]
          : 0,
        "Below Grade Total Area":
          (item["Below Grade Unfinished Area"]
            ? item["Below Grade Unfinished Area"]
            : 0) +
          (item["Below Grade Finished Area"]
            ? item["Below Grade Finished Area"]
            : 0),
        "Below Grade Finished Area": item["Below Grade Finished Area"]
          ? item["Below Grade Finished Area"]
          : 0,
        "Total Square Feet": item["Building Area Total"]
          ? item["Building Area Total"]
          : 0,
        Fireplace: item["Fireplaces Total"] ? item["Fireplaces Total"] : 0,
        "Above Grade Bedrooms":
          item["Upper Level Bedrooms"] +
          item["Main Level Bedrooms"] +
          item["Lower Level Bedrooms"],
        "¾ and Full Bathrooms":
          (item["Bathrooms Full"] || 0) +
          (item["Bathrooms Three Quarter"] || 0),
        "¼ and ½ Bathrooms":
          (item["Bathrooms Half"] || 0) + (item["Bathrooms One Quarter"] || 0),
        "Garage Spaces": item["Garage Spaces"] ? item["Garage Spaces"] : 0,
        // properties_address: item["Unit Number"]
        //   ? `${item["Street Number"]} ${item["Street Dir Prefix"]}  ${item["Street Name"]} ${item["Street Suffix"]} ${
        //       item["City"]
        //     } ${item["State Or Province"]?.slice(0, 2).toUpperCase()} ${
        //       item["Postal Code"]
        //     } (unit ${item["Unit Number"]})`
        //   : `${item["Street Number"]}  ${item["Street Dir Prefix"]}  ${item["Street Name"]} ${item["Street Suffix"]} ${
        //       item["City"]
        //     } ${item["State Or Province"]?.slice(0, 2).toUpperCase()} ${
        //       item["Postal Code"]
        //     }`,
        properties_address: item["Unit Number"]
          ? `${item["Street Number"] || ""} ${item["Street Dir Prefix"] || ""} ${item["Street Name"] || ""} ${item["Street Suffix"] || ""} ${item["City"] || ""} ${item["State Or Province"]?.slice(0, 2).toUpperCase() || ""} ${item["Postal Code"] || ""} (unit ${item["Unit Number"]})`
            .replace(/\s+/g, " ")
            .trim()
          : `${item["Street Number"] || ""} ${item["Street Dir Prefix"] || ""} ${item["Street Name"] || ""} ${item["Street Suffix"] || ""} ${item["City"] || ""} ${item["State Or Province"]?.slice(0, 2).toUpperCase() || ""} ${item["Postal Code"] || ""}`
            .replace(/\s+/g, " ")
            .trim()
        ,
        pdf_address: `${item["Street Number"]}  ${item["Street Name"]}`,

        add_adjustment: true,
        "Public-Remarks": item["Public Remarks"]
          ? item["Public Remarks"]
          : "Not Available",
        "Net Sales Price":
          (item["Close Price"] ? Number(item["Close Price"]) : 0) -
          (item["Concessions Amount"] ? Number(item["Concessions Amount"]) : 0),
        notes: "",
        uuid: getUUID(),
        propertyImages: [],
        selectedAdditionalInfo: [],
        subjectAdditionalInfo: [],
        checked: "",
        agentNotes: "",
        "Listing Id": item["Listing Id"],
        Latitude: item.Latitude,
        Longitude: item.Longitude,
        "Day on market": item["Days In MLS"],
        Exclusions: item.Exclusions,
        Roof: item.Roof,
        "kitchen appliences": item["Appliances"],
        "Prop Type": item["Property Sub Type"],
        County: item["County Or Parish"],
        "Full baths": item["Bathrooms Full"],
        "3/4 baths": item["Bathrooms Three Quarter"],
        "Half baths": item["Bathrooms Half"],
        "List Price": item["List Price"],
        High: item["High School"],
        "Org List Price": item["Original List Price"],
        Elementary: item["Elementary School"],
        "Assoc Fee": item["Association Fee"],
        perSquareFeet: item["PSF Above Grade"] ? item["PSF Above Grade"] : 0,
        "Association Fee Includes": item["Association Fee Includes"],
        "Association Name Primary": item["Association Name"],
        "Basement Type": item["Basement"],
        Concession: item["Concessions Amount"],
        "Construction Materials": item["Construction Materials"],
        cooling: item["cooling"],
        "Exterior Features": item["Exterior Features"],
        "Faces Direction": item["Direction Faces"],
        "Fireplace Features": item["Fireplace Features"],
        Flooring: item["Flooring"],
        Heating: item["Heating"],
        "Interior Features": item["Interior Features"],
        "Is Incorporated YN": item["Is Incorporated YN"],
        "Laundry Features": item["Laundry Features"],
        "Parking Features": item["Parking Features"],
        Restrictions: item["Restrictions Covenants"],
        "Road Surface": item["Road Surface Type"],
        Sewer: item["Sewer"],
        Utilities: item["Utilities"],
        View: item["View"],
        Zoning: item["Zoning"],
        "School District": item["Elementary School District"],
        MLS: item["Listing Id"] ? item["Listing Id"] : "Not Available",
        Neighborhood: item["Subdivision Name"],
        "Structure Style": item["Structure tupe"],
        Taxes: item["Tax Annual Amount"],
        "Unit Number": item["Unit Number"],
        Bedrooms:
          item["Upper Level Bedrooms"] +
          item["Main Level Bedrooms"] +
          item["Lower Level Bedrooms"],
        Bathrooms:
          item["Upper Level Bathrooms"] +
          item["Main Level Bathrooms"] +
          item["Lower Level Bathrooms"],
        added_COMPARABLESLIST: {
          Current_State: item["Mls Status"]
            ? item["Mls Status"]
            : "Not Available",
          Sold_Date: GiveSoldData(item["Close Date"]),
          Sold_Price: item["Close Price"]
            ? item["Close Price"]
            : "Not Available",
        },
        additionalHomeFacts: {
          Location: {
            Undesirable: false,
            Noisy: false,
            Average: false,
            Good: false,
            Amazing: false,
          },
          "Basement Type": {
            None: false,
            "In-Ground": false,
            "Garden Level": false,
            Walkout: false,
          },
          Windows: {
            "Below Average": false,
            Average: false,
            "Above Average": false,
            "Excellent New": false,
          },
          "Kitchen Condition": {
            Dated: false,
            "Typical Average": false,
            "Partial Update Low": false,
            "Partial Update High": false,
            "Full Update": false,
          },
          "Bathroom Condition": {
            Dated: false,
            "Typical Average": false,
            "Partial Update Low": false,
            "Partial Update High": false,
            "Full Update": false,
          },
          "Heating/Cooling": {
            None: false,
            Evaporative: false,
            "Central Air": false,
            "Split Zone": false,
          },
        },
        adjustment_formulas: [],
        review_data: {},
      };
    } else if (detectedType === "PPAR") {
      data = {
        Levels: item["FloorPlan"] || item["Level"] || "",
        "Year Built": item["YearBuilt"],
        "Lot Size": item["LotSizeArea"] ? Math.round(item["LotSizeArea"]) : 0,
        "Above Grade Finished Area": item["SqftAbove"] ? item["SqftAbove"] : 0,
        // "Below Grade Total Area":
        //   (item["sqftTotalBsmt"]
        //     ? item["sqftTotalBsmt"]
        //     : 0) + (item["SqftFinished"] ? item["SqftFinished"] : 0),
        "Below Grade Total Area": item["sqftTotalBsmt"] || 0,
        // "Below Grade Finished Area": item["SqftFinished"]
        //   ? item["SqftFinished"]
        //   : 0,
        // "Below Grade Finished Area":
        //   (item["sqftTotalBsmt"] * item["BasementPercentFinished"]) / 100,
        "Below Grade Finished Area": Math.floor(
          (item["sqftTotalBsmt"] * item["BasementPercentFinished"]) / 100
        ),
        "Total Square Feet": item["SqftTotal"] ? item["SqftTotal"] : 0,
        Fireplace: item["Fireplaces"],
        "Above Grade Bedrooms": item["BedsMain"] + item["BedsUpper"],
        "¾ and Full Bathrooms":
          (item["BathsFull"] || 0) +
          (item["BathsThreeQuarter"] || 0),
        "¼ and ½ Bathrooms": item["BathsHalf"] || 0,
        "Garage Spaces": item["GarageSpaces"] ? item["GarageSpaces"] : 0,
        "Full baths": item["BathsFull"] || item["Bathrooms Full"] || "",
        "3/4 baths": item["BathsThreeQuarter"] || item["Bathrooms Three Quarter"] || 0,
        "Half baths": item["BathsHalf"] || item["Bathrooms Half"] || "",
        // (item["BathsHalf"] || 0) + (item["BathsOneQuarter"] || 0),
        pdf_address: `${item["StreetNumber"]}  ${item["StreetName"]}`,

        add_adjustment: true,
        "Public-Remarks": item["PublicRemarks"] || item["Public Remarks"] || ""
          ? item["PublicRemarks"]
          : "Not Available",
        "Net Sales Price":
          (item["ClosePrice"] ? Number(item["ClosePrice"]) : 0) -
          (item["ConcessionsAmount"]
            ? Number(item["ConcessionsAmount"])
            : 0),
        notes: "",
        uuid: getUUID(),
        propertyImages: [],
        selectedAdditionalInfo: [],
        subjectAdditionalInfo: [],
        checked: "",
        agentNotes: "",
        "Listing Id": item["MLSNumber"] || item["Address"].replaceAll(" ", "-") || "",
        Latitude: item.Latitude,
        Longitude: item.Longitude,
        "Day on market": item["Days In MLS"],
        Exclusions: item.Exclusions,
        Roof: item.Roof,
        "kitchen appliences": item["Appliances"],
        "Prop Type": item["PropertyType"],
        County: item["CountyOrParish"],
        "Full baths": item["BathsFull"] || item["Bathrooms Full"] || "",
        "3/4 baths": item["BathsThreeQuarter"] || item["Bathrooms Three Quarter"] || "",
        "Half baths": item["BathsHalf"] || item["Bathrooms Half"] || "",
        "List Price": item["CurrentPrice"] || "",
        High: item["High School"] || item["HighSchool"] || item["HighSchoolName"] || "",
        "Org List Price": item["ListPrice"] || "",
        Elementary: item["Elementary School"] || item["ElementarySchool"] || item["ElementarySchoolName"] || "",
        "Assoc Fee": item["Association Fee"] || "",
        perSquareFeet: item["SPSqft"] ? item["SPSqft"] : 0,
        "Association Fee Includes": item["Association Fee Includes"] || "",
        "Association Name Primary": item["Association Name"] || "",
        "Basement Type": item["Basement"] || "",
        Concession: item["ConcessionsAmount"] || 0,
        "Construction Materials": item["Construction Materials"] || "",
        cooling: item["Cooling"] || item["cooling"] || "",
        "Exterior Features": item["Exterior Features"] || "",
        "Faces Direction": item["Direction Faces"] || "",
        FirePlaceDesc: item["FirePlaceDesc"] || "",
        Flooring: item["Flooring"],
        Heating: item["Heating"],
        "Interior Features": item["Interior Features"],
        "Is Incorporated YN": item["Is Incorporated YN"],
        "Laundry Features": item["Laundry Features"],
        "Parking Features": item["Parking Features"],
        Restrictions: item["Restrictions Covenants"],
        "Road Surface": item["Road Surface Type"],
        Sewer: item["Sewer"],
        Utilities: item["Utilities"],
        View: item["View"],
        Zoning: item["Zoning"],
        "School District": item["Elementary School District"],
        MLS: item["MLSNumber"] || item["Address"].replaceAll(" ", "-") || "",
        Neighborhood: item["Subdivision Name"],
        "Structure Style": item["FloorPlan"],
        Taxes: item["Tax Annual Amount"],
        "Unit Number": item["Unit Number"],
        Bedrooms: item["BedsLower"] + item["BedsMain"] + item["BedsUpper"],
        Bathrooms: item["BathsTotal"],
        added_COMPARABLESLIST: {
          Current_State: item["Status"] ? item["Status"] : "Not Available",
          Sold_Date: GiveSoldData(item["CloseDate"]),
          Sold_Price: item["ClosePrice"] ? item["ClosePrice"] : "Not Available",
        },
        isPPAR: true,
        properties_address: item["Unit Number"]
          ? `${item["StreetNumber"] || ""} ${item["StreetDirPrefix"] || ""} ${item["StreetName"] || ""} ${item["StreetSuffix"] || ""} ${item["City"] || ""
          } ${item["StateOrProvince"]?.slice(0, 2).toUpperCase() || ""} ${item["PostalCode"] || ""
          } (unit ${item["Unit Number"]})`
          : `${item["StreetNumber"] || ""} ${item["StreetDirPrefix"] || ""} ${item["StreetName"] || ""} ${item["StreetSuffix"] || ""} ${item["City"] || ""
          } ${item["StateOrProvince"]?.slice(0, 2).toUpperCase() || ""} ${item["PostalCode"] || ""
          }`,
        additionalHomeFacts: {
          Location: {
            Undesirable: false,
            Noisy: false,
            Average: false,
            Good: false,
            Amazing: false,
          },
          "Basement Type": {
            None: false,
            "In-Ground": false,
            "Garden Level": false,
            Walkout: false,
          },
          Windows: {
            "Below Average": false,
            Average: false,
            "Above Average": false,
            "Excellent New": false,
          },
          "Kitchen Condition": {
            Dated: false,
            "Typical Average": false,
            "Partial Update Low": false,
            "Partial Update High": false,
            "Full Update": false,
          },
          "Bathroom Condition": {
            Dated: false,
            "Typical Average": false,
            "Partial Update Low": false,
            "Partial Update High": false,
            "Full Update": false,
          },
          "Heating/Cooling": {
            None: false,
            Evaporative: false,
            "Central Air": false,
            "Split Zone": false,
          },
        },
        adjustment_formulas: [],
        review_data: {},
      };
    }
    filterCsvData.push(data);
  });
  return { filterCsvData: filterCsvData, imageIds: imageIds };
};

export const changeFormateOfApiData = (dataAPI, updateState) => {
  const dataMap = {
    "Kitchen Conditon": "Kitchen Condition",
    "Bathrooms Conditon": "Bathrooms Condition",
    "Cooling System": "Heating/Cooling",
  };
  let finalArray = [];
  dataAPI?.forEach((ditem) => {
    updateState?.forEach((item) => {
      if (String(Object.keys(item)) === ditem.style_parent_label) {
        finalArray.push({ [Object.keys(item)]: extractData(ditem) });
      }
    });

    if (dataMap[ditem.style_parent_label]) {
      finalArray.push({
        [dataMap[ditem.style_parent_label]]: extractData(ditem),
      });
    }
  });

  let temp = {};
  if (finalArray.length > 0) {
    temp = convertArrayIntoObject(finalArray, temp);
    return temp;
  }
  return temp;
};
const convertArrayIntoObject = (array, object) => {
  for (let i = 0; i < array.length; i++) {
    Object.assign(object, array[i]);
  }
  return object;
};
function extractData(ditem) {
  return {
    FirstRange: ditem.amt_range_one,
    SecoundRange: ditem.amt_range_two,
    ThirdRange: ditem.amt_range_three,
    style_slug: ditem.style_slug,
  };
}
export const defaultStateValue = {
  FirstRange: "$0-$500,000",
  SecoundRange: "$501,000-$1 Million",
  ThirdRange: "1 Million and over",
  "Year Built": {
    FirstRange: 500,
    SecoundRange: 800,
    ThirdRange: 1000,
  },
  "Lot Size": {
    FirstRange: 1,
    SecoundRange: 1,
    ThirdRange: 1,
  },
  Fireplace: {
    FirstRange: 2000,
    SecoundRange: 5000,
    ThirdRange: 7000,
  },
  Garage: {
    FirstRange: 5000,
    SecoundRange: 8000,
    ThirdRange: 15000,
  },
  Bedrooms: {
    FirstRange: 5000,
    SecoundRange: 10000,
    ThirdRange: 15000,
  },
  "3/4 and Full Bathrooms": {
    FirstRange: 5000,
    SecoundRange: 10000,
    ThirdRange: 15000,
  },
  "1/4 and 1/2 Bathrooms": {
    FirstRange: 5000,
    SecoundRange: 10000,
    ThirdRange: 15000,
  },

  "Basement Type": {
    FirstRange: 10000,
    SecoundRange: 20000,
    ThirdRange: 30000,
  },
  "Heating/Cooling": {
    FirstRange: 3000,
    SecoundRange: 5000,
    ThirdRange: 10000,
  },
  "Kitchen Condition": {
    FirstRange: 4000,
    SecoundRange: 7000,
    ThirdRange: 15000,
  },
  "Bathroom Condition": {
    FirstRange: 5000,
    SecoundRange: 15000,
    ThirdRange: 20000,
  },
  Location: {
    FirstRange: 5000,
    SecoundRange: 15000,
    ThirdRange: 20000,
  },
  Windows: {
    FirstRange: 20000,
    SecoundRange: 30000,
    ThirdRange: 40000,
  },
  "Above grade finished area": {
    FirstRange: 3,
    SecoundRange: 3,
    ThirdRange: 3,
  },
  "Below grade total area": {
    FirstRange: 16.2,
    SecoundRange: 16.2,
    ThirdRange: 16.2,
  },
  "Below grade finished area": {
    FirstRange: 9.25,
    SecoundRange: 9.25,
    ThirdRange: 9.25,
  },
};
export const classifyPercentageColor = (percentage) => {
  if (percentage >= 0 && percentage <= 10) {
    return {
      background:
        "linear-gradient(to right, rgba(27, 224, 67, 0.3) 0%, white 100%)",
    };
  } else if (percentage > 10 && percentage <= 20) {
    return {
      background:
        "linear-gradient(to right, rgb(248 241 0 / 30%) 0%, white 100%)",
    };
  } else {
    return {
      background:
        "linear-gradient(to right, rgba(248, 49, 49, 0.3) 0%, white 100%)",
    };
  }
};
export const classifyPercentageColorForSpan = (percentage) => {
  if (percentage >= 0 && percentage <= 10) {
    return {
      color: "#1dd63d",
    };
  } else if (percentage > 10 && percentage <= 20) {
    return {
      color: "#FFBF00",
    };
  } else {
    return {
      color: "#ef0808",
    };
  }
};
//US formate
export const formatPhoneNumber = (phoneNumber) => {
  const cleaned = ("" + phoneNumber).replace(/\D/g, "");
  const regex = /^(\d{3})(\d{3})(\d{4})$/;
  const formatted = cleaned.replace(regex, "$1-$2-$3");
  return formatted;
};
